import { NgModule } from '@angular/core';
import { PromoteQueryToDatasetDialogService } from '@mode/dataset/contract';
import { PromoteDatasetDialogService } from './promote-dataset-dialog/promote-dataset-dialog.service';

@NgModule({
  imports: [],
  providers: [{ provide: PromoteQueryToDatasetDialogService, useClass: PromoteDatasetDialogService }],
})
export class PromoteDatasetModule {}
